import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter);

const root = process.env.VUE_APP_APP_ROUTING_ROOT_HINA
const root_gogatsu = process.env.VUE_APP_APP_ROUTING_ROOT_GOGATSU

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: root,
      component: require('../pages/index.vue').default
    },

    {
      path: root + '/step',
      component: require('../pages/step/index.vue').default,
      children: [
        {
          path: 'sizes/:order',
          alias: [
            'peoples/:order',
          ],
          components: {
            default: require('@/components/step.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        }, {
          path: 'stages/:order',
          alias: [
            'dolls/:order',
            'options/:order',
            'case/:order',
          ],
          components: {
            default: require('@/components/step.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        }, {
          path: 'complete/:order',
          components: {
            default: require('@/components/complete.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        },
      ]
    },

    {
      path: root_gogatsu,
      component: require('../pages/index_gogatsu.vue').default
    },

    {
      path: root_gogatsu + '/step',
      component: require('../pages/step/index.vue').default,
      children: [
        {
          path: 'sizes/:order',
          alias: [
            'peoples/:order',
          ],
          components: {
            default: require('@/components/step.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        }, {
          path: 'stages/:order',
          alias: [
            'dolls/:order',
            'options/:order',
            'case/:order',
          ],
          components: {
            default: require('@/components/step.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        }, {
          path: 'complete/:order',
          components: {
            default: require('@/components/complete.vue').default,
            sidebar: require('@/components/sidebar.vue').default,
          },
          meta: {
            sidebar: true
          },
        },
      ]
    },

    // 🎎 redirect
    { path: process.env.VUE_APP_APP_ROUTING_ROOT, redirect: root },
    { path: process.env.VUE_APP_APP_ROUTING_ROOT + '/index.html', redirect: root },
    // 404
    { path: root + '/404', component: require('../pages/404/index.vue').default },
    { path: root + '/*', redirect: '/404' },

      // gogatsu redirect
      { path: process.env.VUE_APP_APP_ROUTING_ROOT, redirect: root_gogatsu },
      { path: process.env.VUE_APP_APP_ROUTING_ROOT + '/index.html', redirect: root_gogatsu },
      // 404
      { path: root_gogatsu + '/404', component: require('../pages/404/index.vue').default },
      { path: root_gogatsu + '/*', redirect: '/404' },

  ],
})

export default router
